import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-208">
      <button className="w-full py-4 px-2 flex justify-between items-center text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-209">
        <span className="font-bold text-gray-800 text-lg" data-id="element-210">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-gray-500" data-id="element-211" /> : <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-212" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0'}`} data-id="element-213">
        <p className="text-gray-600 px-2" data-id="element-214">{answer}</p>
      </div>
    </div>;
}
export function FAQ() {
  const faqs = [{
    question: '¿Es material digital?',
    answer: 'Sí. Es 100% digital. Recibís acceso inmediato a la plataforma de descarga y podés acceder al material de por vida desde cualquier dispositivo.'
  }, {
    question: '¿Puedo trabajar desde casa o taller?',
    answer: 'Sí. El sistema está pensado para que lo apliques en tu taller, en domicilio o donde trabajes. Todo el material es portable y práctico.'
  }, {
    question: '¿Necesito experiencia previa?',
    answer: 'No. Los tomos arrancan desde los fundamentos. Si ya tenés experiencia, vas a ordenar lo que sabés y potenciar tu rentabilidad.'
  }, {
    question: '¿Para quién no es este MegaPack?',
    answer: 'No es para personas que buscan teoría sin aplicar. Es un sistema de acción para generar ingresos reales con la reparación de herramientas eléctricas.'
  }];
  return <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-6 md:p-8" data-id="element-215">
      {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-216" />)}
    </div>;
}